import { type FieldValues, type Path, useFormContext } from 'react-hook-form'
import { cn } from '@/helpers/utils'

interface CharCounterProps<T extends FieldValues> {
	name: Path<T>
	maxLength: number
	isDisabled?: boolean
}

export const CharCounter = <T extends FieldValues>({
	name,
	maxLength,
	isDisabled = false
}: CharCounterProps<T>) => {
	const { watch } = useFormContext<T>()
	const value = watch(name) || ''
	const currentLength = value.length
	const isExceeded = currentLength > maxLength

	return (
		<div className='mt-1 flex items-center justify-end'>
			<span
				className={cn(
					'text-xs',
					isExceeded ? 'text-danger-600' : 'text-neutral-600',
					isDisabled && 'text-transparent'
				)}
			>
				{currentLength}/{maxLength}
			</span>
		</div>
	)
}

CharCounter.displayName = 'CharCounter'
